import firebase from '@/config/firebase'
import { firestoreAction } from 'vuexfire'
import globals from '@/config/globals'
import moment from 'moment'

const getDefaultState = () => ({
  collection: null,
  query: null,
  status: {
    value: false,
    data: null
  }
})

const appointments = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setCollection(state, data) {
      state.collection = data
    },

    setQuery(state, data) {
      state.query = data
    },


    setStatus(state, data) {
      state.status = data
    },

    reset(state) {
      Object.assign(state, getDefaultState())
      state.status = { value: false, data: 'Data wiped.' }
    }
  },

  actions: {
    loadCollection: firestoreAction(({
      bindFirestoreRef, commit, rootState, rootGetters
    }) => {
      // Get midday instead of midnight
      // Subtract 12 Hours from current time and set time to midday
      // const m = moment().subtract(12, 'h').set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).toDate()

      const dm = moment().subtract(8, 'd').toDate() // Dentist
      const om = moment().subtract(24, 'h').toDate() // Operator
      const am = moment().subtract(16, 'd').toDate() // Admin
      let query = false
      let response = null

      if (rootGetters['account/type'] === 'dentist') {
        if (rootState.account.profile.dentist) {
          query = firebase.firestore().collection(globals.firebase.collection.appointments)
            .where('dentist.list', 'array-contains', rootState.account.profile.dentist) // Dentist is assigned to the array
            .where('info.created.timestamp', '>', dm) // Appointment date is within the specified time (past 8 days)
            .where('info.status', 'in', [1, 2]) // Appointment status is "booked" OR "cancelled"
        } else {
          commit('setStatus', { value: false, data: 'Missing Dentist Identifier.' })
          console.error('Appointments Load - Error loading dentist ID')
        }
      } else {
        const m = rootGetters['account/type'] === 'operator' ? om : am // if user is not operator then it must be an admin because dentist is checked above
        query = firebase.firestore().collection(globals.firebase.collection.appointments).where('info.created.user', '==', rootState.account.record.uid).where('info.created.timestamp', '>', m)
      }

      if (query) {
        response = bindFirestoreRef('collection', query)
          .then(() => {
            commit('setStatus', { value: true, data: 'Collection bound.' })
            console.info('Appointments collection bound.')
          })
          .catch((error) => {
            commit('setStatus', { value: false, data: error.stack.toString() })
            console.error('Error binding collection (appointments):', error)
          })
      }

      return response
    }),

    reset: firestoreAction(({ commit, unbindFirestoreRef }) => {
      commit('reset')
      unbindFirestoreRef('collection')
    }),

    setRead: firestoreAction(({ rootState }, data) => {
      firebase.firestore().collection(globals.firebase.collection.appointments)
        .doc(data.id)
        .update({ [`dentist.data.${rootState.account.profile.dentist}.read`]: data.status })
    })
  },

  getters: {
    find: (state) => (id) => {
      let result = null
      // Search Collection
      result = state.collection.find((appointment) => appointment.id === id)

      // Search Query if no match was found in collection
      if (state.query && !result) {
        result = state.query.find((appointment) => appointment.id === id)
      }

      return result
    },

    new: (state, getters, rootState) => state.collection.filter((x) => x.dentist.data[rootState.account.profile.dentist].read === false)
  }
}

export default appointments
